export const VOICE_STATES = [
  "normal",
  "self_mute",
  "self_deaf",
  "server_mute",
  "server_deaf",
  "afk",
] as const;

export type VoiceState = (typeof VOICE_STATES)[number];
